/* eslint standard/no-callback-literal:0 */

import async from 'async'
import app from '../app.jsx'
import Util from './util.jsx'

function _onSearchActivity (projectId, extraQuery, callback) {
  const itemParams = {
    query: {
      projectId: projectId,
      type: { $in: ['time-activity'] },
      $select: ['title', 'phaseNo', 'projectId'],
      isActive: true,
      $client: {
        subObjects: {
          project: ['budget', 'startDate', 'endDate']
        }
      },
      $sort: {
        phaseNo: 1,
        orderNo: 1
      }
    }
  }

  if (extraQuery) {
    if (extraQuery.activePhaseNos) {
      itemParams.query.phaseNo = { $in: extraQuery.activePhaseNos }
    }
  }

  app
    .service('/api/project/budgetitem')
    .find(itemParams)
    .then(itemRes => {
      if (itemRes) {
        const options = itemRes.data.map(obj => {
          const phases = obj.project.budget.phases
          const phaseName =
            phases && phases.length > 0 ? phases[obj.phaseNo - 1].title : ''
          const title =
            phaseName === '' ? obj.title : `${obj.title} - ${phaseName}`
          return { label: title, value: obj.id, project: obj.project }
        })

        callback(options)
      } else {
        callback([])
      }
    })
    .catch(err => {
      app.debug('TimeUtil: _onSearchActivity Error', err)
      callback([])
    })
}

function _createTimeCard (timeCard, callback) {
  const currDate = new Date()
  if (!timeCard.createdOn) {
    timeCard.createdOn = currDate
  }

  timeCard.createdOn = new Date(
    timeCard.createdOn.getFullYear(),
    timeCard.createdOn.getMonth(),
    timeCard.createdOn.getDate(),
    currDate.getHours(),
    currDate.getMinutes(),
    currDate.getSeconds()
  )

  if (
    app.isDemo &&
    (timeCard.description === undefined || timeCard.description === '')
  ) {
    timeCard.description = Util.getRandomDescription()
  }

  app
    .service('/api/timecard')
    .create(timeCard)
    .then(createRes => {
      if (createRes) {
        callback(createRes)
      }
    })
    .catch(createErr => {
      app.debug('TimeUtil: _createTimeCard Error', createErr)
    })
}

function _createUserTask (timeCard, callback) {
  const createObj = {
    userId: app.loggedInId,
    projectId: timeCard.projectId,
    activityId: timeCard.activityId,
    taskId: timeCard.taskId,
    timeCardId: timeCard.id,
    status: 'started'
  }
  const currDate = new Date()
  const params = {
    query: {
      $client: {
        activeDate: new Date(
          currDate.getFullYear(),
          currDate.getMonth(),
          currDate.getDate()
        )
      }
    }
  }

  app
    .service('/api/usertask')
    .create(createObj, params)
    .then(userTaskRes => {
      if (callback) {
        callback(userTaskRes)
      }
    })
    .catch(err => {
      app.debug('TimeUtil: _createUserTask Error', err)
    })
}

function _updateUserTask (userTaskId, updateObj, callback) {
  app
    .service('/api/usertask')
    .patch(userTaskId, updateObj)
    .then(_userTaskRes => {
      if (callback) {
        callback()
      }
    })
    .catch(err => {
      app.debug('TimeUtil: _updateUserTask Error', err)
    })
}

function _updateTimeCardDetail (timeCardId, detailObj, timer, bStopTimer) {
  app
    .service('/api/timecard')
    .patch(timeCardId, detailObj)
    .then(updateRes => {
      // Update task
      if (
        timer.TaskId() &&
        timer.isAssignedToProjectActivity() &&
        updateRes.projectId &&
        updateRes.activityId
      ) {
        const updateObj = {
          projectId: updateRes.projectId,
          activityId: updateRes.activityId
        }

        app
          .service('/api/project/plannertask')
          .patch(timer.TaskId(), updateObj)
          .then(_updateRes => {})
          .catch(updateErr => {
            app.debug(
              'TimeUtil: _updateTimeCardDetail - Update Task - Error',
              updateErr
            )
          })
      }

      // Update details in usertask
      if (timer.doesRelateToTimeCardId(timeCardId)) {
        const updateObj = {
          projectId: updateRes.projectId,
          activityId: updateRes.activityId,
          taskId: updateRes.taskId,
          activity: updateRes.activity
        }

        if (bStopTimer) {
          updateObj.status = 'stopped'
        }

        _updateUserTask(timer.ID(), updateObj)
      }
    })
    .catch(updateErr => {
      app.debug('PageTime: _onUpdateTimeCardDetail Error', updateErr)
    })
}

function _onGetTasks (projectId, activityId, callback) {
  const taskParams = {
    query: {
      projectId: projectId,
      activityId: activityId,
      userId: app.loggedInId
    }
  }

  app
    .service('/api/project/plannertask')
    .find(taskParams)
    .then(itemRes => {
      if (itemRes) {
        const options = itemRes.data.map(obj => {
          return { label: obj.title, value: obj.id }
        })

        callback(options)
      } else {
        callback([])
      }
    })
    .catch(err => {
      app.debug('PageTime: _onGetTasks Error', err)
      callback([])
    })
}

function _onCompleteTask (taskId) {
  if (taskId) {
    const updateObj = {
      completed: true
    }
    app
      .service('/api/project/plannertask')
      .patch(taskId, updateObj)
      .then(_updateRes => {})
      .catch(updateErr => {
        app.debug('TimeUtil: _onCompleteTask Error', updateErr)
      })
  }
}

function _createFavorite (timeCard, callback) {
  const createObj = {
    userId: app.loggedInId,
    projectId: timeCard.projectId ? timeCard.projectId : null,
    activityId: timeCard.activityId ? timeCard.activityId : null,
    customActivityType: timeCard.activity ? timeCard.activity : '',
    teamId: app.getTeamId()
  }

  app
    .service('/api/timecard/favorite')
    .create(createObj)
    .then(_createFavRes => {
      if (callback) {
        callback(null)
      }
    })
    .catch(createFavErr => {
      app.debug('TimeUtil: _createFavorite Error', createFavErr)
      if (callback) {
        callback(createFavErr)
      }
    })
}

function _updateFavorite (timeCard, bFavorite, callback) {
  const activityType = timeCard.customActivityType
    ? timeCard.customActivityType
    : timeCard.activity
  if (bFavorite) {
    _createFavorite(timeCard, callback)
  } else {
    const removeParams = {
      query: {
        userId: app.loggedInId
      }
    }

    if (timeCard.projectId !== null && timeCard.activityId !== null) {
      removeParams.query.projectId = timeCard.projectId
      removeParams.query.activityId = timeCard.activityId
    } else {
      removeParams.query.customActivityType = activityType
    }

    app
      .service('/api/timecard/favorite')
      .remove(null, removeParams)
      .then(_deleteFavRes => {
        if (callback) {
          callback(null)
        }
      })
      .catch(deleteFavErr => {
        app.debug('TimeUtil: _updateFavorite Error', deleteFavErr)

        if (callback) {
          callback(deleteFavErr)
        }
      })
  }
}

function _updateFavorites (timeCardIds, bFavorite, callback) {
  if (timeCardIds && timeCardIds.length > 0) {
    async.mapSeries(
      timeCardIds,
      (timeCardId, done) => {
        _updateFavorite(timeCardId, bFavorite, done)
      },
      (asyncErr, _asyncRes) => {
        if (asyncErr) {
          app.debug('TimeUtil: _updateFavorites Error', asyncErr)
        }

        if (callback) {
          callback(asyncErr)
        }
      }
    )
  }
}

function _updateFavoriteOrder (favouriteId, updateObj, callback) {
  app
    .service('/api/timecard/favorite')
    .patch(favouriteId, updateObj)
    .then(_updateFavRes => {
      if (callback) {
        callback(null)
      }
    })
    .catch(createFavErr => {
      app.debug('TimeUtil: _updateFavoriteOrder Error', createFavErr)
      if (callback) {
        callback(createFavErr)
      }
    })
}

const TimeUtil = {}
TimeUtil.onSearchActivity = _onSearchActivity
TimeUtil.createTimeCard = _createTimeCard
TimeUtil.createUserTask = _createUserTask
TimeUtil.updateUserTask = _updateUserTask
TimeUtil.updateTimeCardDetail = _updateTimeCardDetail
TimeUtil.onGetTasks = _onGetTasks
TimeUtil.onCompleteTask = _onCompleteTask
TimeUtil.createFavorite = _createFavorite
TimeUtil.updateFavorite = _updateFavorite
TimeUtil.updateFavorites = _updateFavorites
TimeUtil.updateFavoriteOrder = _updateFavoriteOrder

export default TimeUtil
